module.exports = __webpack_public_path__ + "static/media/success.691275a9.gif";